<template>
  <div class="container-fluid p-4 p-sm-5">
    <loading v-show="showLoader"/>
    <div class="row mb-4">
      <div class="col-12">
        <ul class="list-inline">
          <li class="list-inline-item"><h1>Complaints Listing</h1></li>
          <form action="" class="float-right ml-auto">
            <li class="list-inline-item">
              <ul class="list-inline">
                <li class="list-inline-item">
                  <div class="field in-search-field">
                    <input type="text" id="texto" class="input-placeholder input-search jbl-search-field" placeholder="Search here..." v-on:keyup="filterSearch" />
                  </div>
                </li>
              </ul>
            </li>
            <li class="list-inline-item">
              <div class="field jbl-responsive-btn">
                <router-link :to="{ name: 'ComplaintCreate' }" class="jbl-btn-primary jbl-responsive-btn">ADD COMPLAINT</router-link>
              </div>
            </li>
          </form>
        </ul>
      </div>
    </div>

    <div id="self-Claim">
      <table class="claim-listing">
        <tbody>
            <tr v-for="complain in complains" :key="complain.ticket_id" @click="viewComplaint(complain.id)">
              <td class="jbl-responsive-td">
                <img :src="require('@/assets/images/jbl-complaint-listing.png')" class="img-fluid">
              </td>
                <td class="jbl-table-heading jbl-responsive-td">Complaint Number {{ complain.ticket_id }}</td>
                <td class="jbl-responsive-td">
                  <div class="jbl-flex-td">
                    <div class="jbl-date-td jbl-date-heading">Description.</div>
                    <div class="jbl-date-td">{{ complain.description}}</div>
                  </div>
                </td>
                <td class="jbl-responsive-td">
                  <div class="jbl-flex-td">
                    <div class="jbl-date-td jbl-date-heading">Date.</div>
                    <div class="jbl-date-td">{{ formatDate(complain.created_at) }}</div>
                  </div>
                </td>
                <td class="jbl-responsive-td">
                  <div class="jbl-flex-td">
                    <div class="jbl-date-td jbl-date-heading">Complaint Type.</div>
                    <div class="jbl-date-td" style="text-transform: capitalize;">{{ complain.complain_type }}</div>
                  </div>
                </td>
                <td class="jbl-responsive-td"><div class="jbl-status-approve text-capitalize">{{ complain.status }}</div></td>
                <td class="jbl-responsive-td in-w-60">
                  <router-link :to="{ name: 'ClaimsView', params: { id: complain.ticket_id } }" class="nex-Page-Link">
                    <!-- <i class="fa fa-chevron-right"></i> -->
                    <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                  </router-link>
                </td>
            </tr>
        </tbody>
      </table>
      <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="complains.length === 0">No Self Policy Found</h2>
    </div>

  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'Complaint',
    components: {
      loading
    },
    data () {
      return {
        showLoader: true,
        complainsList: {},
        complains: {},
        complaints : {},
      };
    },
    created: function () {
      const self = this;
      //self.getComplains();
      self.$router.push({ name: 'ComplaintFeedback' });
    },
    methods: {
      formatDate (date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async getComplains () {
        var self = this;
        await axios.get('customer/complains').then(function (resp) {
          if (resp.data.code == 200) {
            self.complains = resp.data.data;
            self.complaints = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
          }
          self.showLoader = false;
        }).catch(function (resp) {
          $toast.error('Please Fill up the fields.', { position: 'top-right' });
          self.showLoader = false;
        });
      },
      filterSearch (key) {
        const self = this;
        self.complains = self.complaints.filter(x => x.title.toLowerCase().includes(key.target.value.toLowerCase()));
      },
      viewComplaint (complainId) {
        const self = this;
        self.$router.push({ name: 'ComplaintView', params: { id: complainId } });
      }
    }
  };
</script>

<style scoped>
@media(max-width:550px){
  .ib-acq-navtab .acq-nav-btn{
    padding: 6px 22px !important;
    width: max-content !important;
    font-size: 12px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Complaint/Index.vue